import React from 'react'

import ServicesSection from '../sections/ServicesSection'

const ServicesPage = ({ theme, language }) => {
  return <ServicesSection language={language} theme={theme} />
}

export default ServicesPage
